

import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import {MdKeyboardArrowRight} from "react-icons/md"
import { useEffect } from "react"
import textFilter from "../../../../helper/textFilter"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import { updateSigortaItemStatus } from "../../../../features/sigorta/sigortaSlice"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    position: relative;
    background-color: ${({theme}) => theme.mainBgColor};

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.secondaryBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        color: ${({ theme }) => theme.mainTextColor};
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.secondaryBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 300px;
        overflow: auto;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: ${({ theme }) => theme.mainTextColor};
            background-color: ${({theme}) => theme.mainBgColor};

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }

`

const InputSelectForUetdsNotification = ({data, setData, isRequired, labelText, name, inputWidth, initialOptions}) => {

    const [text, setText] = useState(data)
    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)

    const [options, setOptions] = useState([])

    useEffect(()=>{
        setOptions(initialOptions)
    },[initialOptions])

    //! her zaman state deki değeri al
    useEffect(() => {
        setText(data)
    },[data])

    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(!searchText){
            setOptions(initialOptions)
            // dispatch(handleActiveSelect(null))
        }

        else{
            const result = textFilter(initialOptions, searchText, "text")
            setOptions(result)
        }
        setText(searchText)
    }

    const handleOptionClick = (item) => {

        dispatch(handleActiveSelect(null))
        
        setData(item)
    }

  return (
    <Container value={text} radius={"5px"} isActive={activeSelect === name} inputWidth={inputWidth} onClick={(e) => e.stopPropagation()}>
        <input type="text" id={"text"} onChange={handleChange} value={text} name={"text"} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}{isRequired && "*"}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        options.map((item) => (
                            <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                                {item.text}
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default InputSelectForUetdsNotification